import { useRef, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : "/api";

// Champs a pre-remplir, en texte, uniquement ceux que la lecture a trouves.
export const champsLus = (r) => {
  const out = {};
  if (r?.ca_ttc != null) out.ca_ttc = String(r.ca_ttc);
  if (r?.ca_ht != null) out.ca_ht = String(r.ca_ht);
  if (r?.nombre_plats != null) out.nombre_plats = String(r.nombre_plats);
  return out;
};

const fr = (n) => (n == null ? "-" : `${Number(n).toFixed(2).replace(".", ",")} €`);

// Bouton « Photographier mon ticket Z » : la photo est lue par le serveur, les
// montants trouves pre-remplissent le formulaire, l'adherent verifie et valide.
// chemin : "/ticket-z/lire" (compte connecte) ou "/ticket-z/lire/<jeton>" (lien e-mail).
export default function ScanTicketZ({ chemin = "/ticket-z/lire", onLu }) {
  const champ = useRef(null);
  const [etat, setEtat] = useState("");
  const [lu, setLu] = useState(null);
  const [erreur, setErreur] = useState("");

  const choisir = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (f.size > 10 * 1024 * 1024) { setErreur("Photo trop lourde (10 Mo maximum)."); return; }
    setEtat("lecture"); setErreur(""); setLu(null);
    try {
      const form = new FormData();
      form.append("fichier", f);
      const r = await axios.post(`${API}${chemin}`, form, { headers: { "Content-Type": "multipart/form-data" } });
      setLu(r.data);
      onLu?.(r.data);
    } catch (x) {
      const d = x?.response?.data?.detail;
      setErreur(typeof d === "string" ? d : "Lecture impossible : saisissez les montants à la main.");
    }
    setEtat("");
  };

  return (
    <div style={{ border: "1px dashed #b9c9c1", borderRadius: 8, padding: 12, background: "#f3f8f5", margin: "8px 0" }}>
      <input ref={champ} type="file" accept="image/*" capture="environment" onChange={choisir} style={{ display: "none" }} />
      <button type="button" onClick={() => champ.current?.click()} disabled={etat === "lecture"}
        style={{ width: "100%", padding: "12px 14px", fontSize: 16, fontWeight: 600, borderRadius: 8, border: 0,
                 background: "#1f4e3d", color: "#fff", cursor: "pointer", opacity: etat === "lecture" ? 0.7 : 1 }}>
        {etat === "lecture" ? "Lecture du ticket en cours…" : "📷 Photographier mon ticket Z"}
      </button>
      {!lu && !erreur && (
        <p style={{ fontSize: 12, color: "#555", margin: "8px 0 0" }}>
          Prenez le ticket de fin de service de votre caisse, bien à plat et en entier : les montants se remplissent tout seuls.
        </p>
      )}
      {lu && (
        <div style={{ fontSize: 13, color: "#1f4e3d", marginTop: 8 }}>
          <strong>Ticket lu</strong>{lu.date ? ` du ${lu.date.slice(8, 10)}/${lu.date.slice(5, 7)}/${lu.date.slice(0, 4)}` : ""} :
          {" "}CA TTC {fr(lu.ca_ttc)}, CA HT {fr(lu.ca_ht)}{lu.nombre_plats != null ? `, ${lu.nombre_plats} articles` : ""}.
          <br /><span style={{ color: "#8a5a00" }}>Vérifiez les montants avant de valider.</span>
          {(lu.avertissements || []).map((a) => <div key={a} style={{ color: "#8a5a00" }}>• {a}</div>)}
        </div>
      )}
      {erreur && <p style={{ fontSize: 13, color: "#b00020", margin: "8px 0 0" }}>{erreur}</p>}
    </div>
  );
}
